import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dialog-tnc',
  templateUrl: './dialog-tnc.component.html',
  styleUrls: ['./dialog-tnc.component.css']
})
export class DialogTncComponent implements OnInit {
  @Input() consent: any;
  @Output() btnAction: EventEmitter<any> = new EventEmitter();
  @ViewChild('top') topPolicy!: ElementRef;

  currentlang: any;
  drawerTncIoh: boolean = false;
  platform: any;
  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  async ngOnInit() {
    setTimeout(() => {
      this.topPolicy.nativeElement.scrollIntoView();
    }, 100);
    // if (this.dialogType === 'update_warning') {
    //   this.icon = 'dialog-confirmation';
    // } else if (this.dialogType === 'invalid_number' || this.dialogType === 'fetch_consent') {
    //   this.icon = 'dialog-error';
    // } else if (this.dialogType === 'tick_both_tnc') {
    //   this.icon = 'icon-error';
    // } else {
    //   this.icon = 'dialog-success';
    // }
    this.currentlang = localStorage.getItem('language');
    this.platform = localStorage.getItem('platform');

    //this.topPolicy.nativeElement.scrollIntoView();

    if (this.consent === 'ioh') {
      this.drawerTncIoh = true;
    } else {
      this.drawerTncIoh = false;
      //this.bottomPolicy.nativeElement.scrollIntoView();
    }
  }

  doAction() {
    this.btnAction.emit();
  }

  close() {
    this.activeModal.close();
  }
}
